import { CardCountBreakdown, CARD_GRADES } from '../../types/cards';
import './CardCountSummary.css';

interface CardCountSummaryProps {
  breakdown: CardCountBreakdown;
  total: number;
}

const gradeLabels: Record<string, string> = {
  SS: 'SS',
  S: 'S',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
};

const gradeKeyMap: Record<string, keyof CardCountBreakdown> = {
  SS: 'ssgrade_card_count',
  S: 'sgrade_card_count',
  A: 'agrade_card_count',
  B: 'bgrade_card_count',
  C: 'cgrade_card_count',
  D: 'dgrade_card_count',
};

export function CardCountSummary({ breakdown, total }: CardCountSummaryProps) {
  return (
    <section className="card-summary">
      <div className="card-summary__header">
        <h2>보유 카드 현황</h2>
        <span className="card-summary__total">
          총 {total.toLocaleString()}장
        </span>
      </div>
      <div className="card-summary__grid">
        {CARD_GRADES.map((grade) => (
          <div key={grade} className={`card-summary__item card-summary__${grade.toLowerCase()}`}>
            <span className="card-summary__grade">{gradeLabels[grade]}</span>
            <span className="card-summary__count">
              {(breakdown[gradeKeyMap[grade]] ?? 0).toLocaleString()}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}


